import React from "react";
import {RS_COLOR_BLACK, RS_COLOR_WHITE} from "@rescui/colors";
import {AddOutlineIcon, CloseIcon} from "@rescui/icons";
import {Tag} from "@rescui/tag";
import cn from "classnames";

import "./index.css";

import {useEdits} from "contexts/edits";
import Textarea from "layout/Textarea/Textarea";

export const Tags = ({className = ""}) => {
  const {tags, setTags} = useEdits();

  const addTag = (tagKey) => {
    setTags({...tags, [tagKey]: ""});
  };

  const removeTag = (tagKey) => {
    const draft = {...tags};
    delete draft[tagKey];
    setTags(draft);
  };

  return (
    <div className={cn("with-tags__tags-wrapper", className)}>
      {Object.keys(tags).map((tagKey) => (
        <Tag
          key={tagKey}
          color={RS_COLOR_BLACK}
          backgroundColor={"#21D789"}
          size="l"
          className="editabletag with-tags__tag"
        >
          <Textarea id={tagKey} text={tags[tagKey]} inline />
          <div
            className="with-tags__remove-tag-button"
            role="button"
            onClick={() => removeTag(tagKey)}
          >
            <CloseIcon color={RS_COLOR_WHITE} />
          </div>
        </Tag>
      ))}

      {Object.keys(tags).length < 4 && (
        <Tag
          color={RS_COLOR_BLACK}
          borderColor={"#21D789"}
          size="l"
          className="with-tags__add-tag-button"
          onClick={() => addTag(`tag-${Object.keys(tags).length + 1}`)}
        >
          <AddOutlineIcon
            size="l"
            color={"#21D789"}
            className={"with-tags__add-tag-icon"}
            width={100}
          />
        </Tag>
      )}
    </div>
  );
};
